export default __webpack_public_path__ + "static/media/roth_ira_light.647d23ad.png";